export default __webpack_public_path__ + "static/media/edit_icon_gray.8ea24644.svg";